import { render, staticRenderFns } from "./Preheader.vue?vue&type=template&id=71171e10&"
import script from "./Preheader.vue?vue&type=script&lang=js&"
export * from "./Preheader.vue?vue&type=script&lang=js&"
import style0 from "./Preheader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports